import React, { useEffect } from "react";
import { List } from "semantic-ui-react";
import styled from "styled-components";
import { useSelector, useDispatch } from "react-redux";
import { loadUser } from "../../redux/user-redux/userStore";

const ArtisteProfile = () => {
  const dispatch = useDispatch();
  const user = useSelector(({ useReducer: { user } }) => user);
  const localStore = JSON.parse(sessionStorage.getItem("auth_user"));
  useEffect(() => {
    if (localStore) {
      loadUser(dispatch);
    }
  });
  const fullname = user && user.first_name + " " + user.last_name;
  return (
    <Container>
      <Logo>
        {user.profile_pic ? (
          <Image>
            <img src={user.profile_pic} alt='Profile' />
          </Image>
        ) : (
          <Round>{user && user.first_name.slice(0, 2).toUpperCase()}</Round>
        )}
      </Logo>
      <Header>
        <h1>@{user.first_name}</h1>
        <span>@{user.last_name}</span>
      </Header>
      <Body>
        <h3>BIO:</h3>
        <p>{user.biography}</p>

        <List>
          <List.Item
            style={{ padding: "0.8em" }}
            icon='users'
            content={fullname}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='marker'
            content={user && user.state + ", " + user.country}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='mail'
            content={<p>{user.email}</p>}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='male'
            content={<p>{user.sex}</p>}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='phone'
            content={<p>{user.phone_number}</p>}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='birthday cake'
            content={<p>{user.date_of_birth}</p>}
          />
          <List.Item
            style={{ padding: "0.8em" }}
            icon='linkify'
            content={
              <p>
                {`${user && "Registered"}`} {user.created_at}
              </p>
            }
          />
        </List>
      </Body>
    </Container>
  );
};

export default ArtisteProfile;

export const Container = styled.div``;
export const Header = styled.div``;
export const Body = styled.div`
  padding: 2em 0;

  h3 {
    margin: 0;
  }
`;

export const Image = styled.div`
  img {
    width: 150px;
    height: 150px;
    border-radius: 50%;
  }
`;
export const Logo = styled.div`
  margin-bottom: 2em;
  width: 150px;
  height: 150px;
`;
export const Round = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5em;
  background: dodgerblue;
  color: white;
`;
